import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  damagedFromModel,
  validateDamagedCondition,
  type DamagedState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const DAMAGED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DamagedState>>,
): ConditionType<DamagedState, Condition.Damaged> => ({
  name: CONDITION_NAMES[Condition.DAMAGED],
  description(state) {
    return t("Return is for damaged product");
  },
  Details(props: ConditionTypeDetailsProps<DamagedState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return damagedFromModel(model);
  },
  toModel(state) {
    return { type: Condition.DAMAGED };
  },
  valid(state) {
    return validateDamagedCondition(state).valid;
  },
});
